import { useContext, useEffect, useRef, useState } from "react";
import { ConstantAPISContext } from "../../../context/ConstantAPISContext";
import CopToplamaAPI from "../../../apis/OB/Get/CopToplamaAPI";
import CaddeSokakAPI from "../../../apis/OB/Get/CaddeSokakAPI";
import { showToast } from "../../../helpers/ToastifyHelper";
import "./CopToplamaSaatleri.css";
import TableComponent from "../../../components/OB/TableComponent";
import SearchComponent from "../../../components/OB/SearchComponent";
import Select from '@mui/material/Select';
import { FormControl, InputLabel, MenuItem, CircularProgress } from "@mui/material";
import { Form, Formik } from "formik";
import ListHeaderComponent from "../../../components/OB/ListHeaderComponent";

const CopToplamaSaatleri: React.FC = () => {

    const columns = [
        { header: "Cadde/ Sokak Adı", field: "caddeSokakAdi", className: "text-start" },
        { header: "Günler", field: "gunler", className: "text-center" },
        { header: "Başlama Saati", field: "baslamaSaati", className: "text-center" },
        { header: "Bitiş Saati", field: "bitisSaati", className: "text-center" },
        { header: "Açıklama", field: "aciklama", className: "text-center" },
    ];
    const [data, setData] = useState<any[]>([]);
    const [searchControl, setSearchControl] = useState<boolean>(true);
    const { mahalleListe } = useContext(ConstantAPISContext);
    const [selectedMahalleKodu, setSelectedMahalleKodu] = useState<any>(undefined);
    const [selectedCaddeSokakKodu, setSelectedCaddeSokakKodu] = useState<any>(undefined);
    const [caddeSokakDatas, setCaddeSokakDatas] = useState<any[]>([]);
    const [isSearched, setIsSearched] = useState<boolean>(false);
    const [isLoading, setisLoading] = useState<boolean>(false);

    //CopToplamaSaatleriAPI
    useEffect(() => {

    }, [])

    const fetchData = async () => {
        if (selectedMahalleKodu !== undefined) {
            setisLoading(true);
            const response = await CopToplamaAPI.getCopToplamaListe(
                selectedMahalleKodu,
                selectedCaddeSokakKodu
            );
            setData(response.data);
            setTimeout(() => {
                setisLoading(false);

            }, 100)
            setSearchControl(true)
            setIsSearched(true);


        }
        else {
            setSearchControl(false)
            showToast("Lütfen Mahalle Seçiniz", "error");
        }
    }
    //CaddeSokakAPI
    useEffect(() => {
        if (
            selectedMahalleKodu !== undefined &&
            !Number.isNaN(selectedMahalleKodu)
        ) {
            CaddeSokakAPI.getCaddeSokakListe(undefined, selectedMahalleKodu)
                .then((res) => {
                    setCaddeSokakDatas(res.data);
                })
                .catch((err) => {
                });
        }
    }, [selectedMahalleKodu]);
    //Temizleme fonksiyonu
    const handleTemizle = () => {
        setSelectedMahalleKodu(undefined);
        setSelectedCaddeSokakKodu(undefined);
    }

    //Formik constantları
    const initialValues = {
        //boş kalacak ihtiyaca göre kullanılabilir
    };
    return (
        <div className="px-1 px-md-2 px-lg-4 py-3 card   w-100">
            <div className="card-body p-0">
                <Formik
                    initialValues={initialValues}
                    onSubmit={() => { }}>
                    <Form id="kayit-form" className="d-flex w-100 mb-4">
                        <div className="d-flex flex-column flex-sm-row w-100 gap-3 ml-2 mr-2">
                            <div className="d-flex flex-column flex-sm-row gap-2 w-100">
                                <FormControl size="small"
                                    sx={{
                                        width: {
                                            xs: "100%",
                                            sm: "50%",
                                            md: "25%",
                                        },
                                        minWidth: 140
                                    }}>

                                    <InputLabel id="">Mahalle</InputLabel>
                                    <Select
                                        sx={{
                                            backgroundColor: "white"
                                        }}
                                        labelId=""
                                        id=""
                                        name="mahalle"
                                        label="Mahalle"
                                        error={selectedMahalleKodu == undefined && searchControl == false ? true : false}

                                        value={selectedMahalleKodu || ""}
                                        onChange={(e) => {
                                            setSelectedMahalleKodu(Number(e.target.value || undefined));
                                            setSelectedCaddeSokakKodu(undefined);
                                        }}                                >
                                        {mahalleListe.map((item) => (
                                            <MenuItem
                                                key={item}
                                                value={item.mahalleKodu}                                            >
                                                {item.mahalleAdi}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl size="small"
                                    sx={{
                                        width: {
                                            xs: "100%",
                                            sm: "50%",
                                            md: "25%",
                                        },
                                        minWidth: 140
                                    }}>

                                    <InputLabel id="">Cadde/Sokak</InputLabel>
                                    <Select
                                        sx={{
                                            backgroundColor: "white"
                                        }}
                                        labelId=""
                                        id=""
                                        value={selectedCaddeSokakKodu || ""}
                                        label="Cadde/Sokak"
                                        onChange={(e) => {
                                            setSelectedCaddeSokakKodu(Number(e.target.value || undefined));
                                        }}                                >
                                        {caddeSokakDatas.map((item) => (
                                            <MenuItem
                                                key={item}
                                                value={item.caddeSokakKodu}                                            >
                                                {item.caddeSokakAdi}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="d-flex  flex-row ms-auto ">
                                <SearchComponent
                                    fetchData={fetchData}
                                    onTemizle={handleTemizle}
                                    setData={setData} />
                            </div>
                        </div>
                    </Form>
                </Formik>
                {isLoading ?
                    <div className="d-flex w-100 justify-content-center align-items-center" style={{ height: '10rem' }}>

                        <CircularProgress />
                    </div>
                    :
                    <TableComponent columns={columns} data={data} recordsPerPage={12} isSearched={isSearched}></TableComponent>
                }
            </div >
        </div >
    )
}

export default CopToplamaSaatleri;